import { COLORS } from '@btime/constants'
import { capitalizeAllIfLower } from '@btime/helpers'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { Text } from '../../components/presentation/Text'
import { UserAvatar } from '../../components/presentation/Avatar'
import { useOpenUserModal } from '../../utils/routes/modals/modalsActions'
import FlexGrid from '../../components/structure/FlexGrid'
import Icon from '../../components/shapes/Icon'
import Link from '../../components/actions/Link'

const UserPresenter = ({ user, size, fontSize, hideIcon, hideAvatar, hideEmptyMessage, ...props }) => {
  const { t } = useTranslation()
  const openDetailsModal = useOpenUserModal()
  if (!user || !user.id) {
    if (!!hideEmptyMessage) return false
    return <Text {...props}>{t('noUser')}</Text>
  }

  return (
    <Link block onClick={() => openDetailsModal(user)} underlineOnHover>
      <FlexGrid justify="flex-start" gutter={0.2}>
        {!hideAvatar && <UserAvatar user={user} size={size} />}
        <Text size={fontSize} {...props}>
          {capitalizeAllIfLower(user.name)}
        </Text>
        {!hideIcon && <Icon name="BsSearch" color={COLORS.dark3} size="0.8rem" />}
      </FlexGrid>
    </Link>
  )
}

export default UserPresenter
